<script>
	import { updateBookmark } from '../../../helpers/bookmark';
	import { user, profileData } from '../../../store';

	import Icon from '../../atoms/Icon.svelte';
	import heart from '../../../../public/assets/svg/24/heart.svg';
	import share_arrow from '../../../../public/assets/svg/24/share_arrow.svg';
	import chat from '../../../../public/assets/svg/24/chat.svg';
	import Loader from '../../atoms/Loader.svelte';
	import Egg from '../../atoms/Egg.svelte';
	
	export let idea;
	export let docId;
	export let ideaImageAbsolutePath;
	export let authorData;
	export let timestamp;
	export let shareData;
	export let activeIndex = 0;
	
	let isSaved;
	let saving = false;

	$: if ($profileData && $profileData.saved) {
        isSaved = $profileData.saved.includes(docId) ? true : false;
    };

	const sharing = async () => {
		if(navigator.share) {
			try {
				await navigator.share(shareData);
				console.log('Idea shared successfully');
			} catch (err) {
				console.log(`Error: ${err}`);
			}
		} else if (navigator.clipboard) {
			try {
				await navigator.clipboard.writeText(window.location.href);
				alert('Link copied. Paste it somewhere to share.')
			} catch (err) {
				alert ('Couldn\'t share. Try again later.')
			}
		}
	}

	const bookmarkHanlder = async (update, user, docId) => {
		if(saving) return;
		saving = true;
		if(user) {
			await updateBookmark(update, user, docId);
		} else {
			// Intercept anonymous users who have opened an idea via deep link. Fair enough for now. Later, a login prompt is desirable.
			alert('Please login to like this idea.');
		}
		saving = false;
    }

</script>

<style lang="scss" src="./ModalIdea.scss"></style>

<div class="ModalIdea">
	{#if idea}
		<div class="ModalIdea__media">
			{#if ideaImageAbsolutePath}
				<img class="ModalIdea__media__image" src="{ideaImageAbsolutePath}" alt="{idea.title}">
			{/if}
			<div class="ModalIdea__media__egg">
				<Egg letter={idea.title.charAt(0)} cssClass={'is-modal'}></Egg>                
			</div>
		</div>
		<div class="ModalIdea__text">
			{#if authorData}
				<div class="ModalIdea__author">
					<img class="ModalIdea__author__image" src="{authorData.picture}" alt="author">
					<div class="ModalIdea__author__meta">
						<span class="ModalIdea__author__name">{authorData.name}</span>
						<small>{timestamp}</small>
					</div>
				</div>	
			{/if}
			<h2 class="ModalIdea__title">
				{idea.title}
			</h2>
			{#if idea.text}
				<p class="ModalIdea__copy">
					{idea.text}
				</p>
			{/if}
			<div class="ModalIdea__interactions">
				<div class="ModalIdea__interaction" class:bookmark--saving={saving} on:click={() => bookmarkHanlder(isSaved ? 'remove' : 'add', $user, docId)}>
					<Icon data={heart} size={'22px'} fill={isSaved ? 'white' : 'none' }></Icon>
					<small class="ModalIdea__interaction__label">
						{idea?.saveCount || 0}
					</small>
				</div>
				<div class="ModalIdea__interaction" on:click={() => activeIndex = 1}>
					<Icon data={chat} fill='none'></Icon>
					<small class="ModalIdea__interaction__label">
						{idea?.messageCount || 0}
					</small>
				</div>
				<div class="ModalIdea__interaction" on:click={sharing}>
					<Icon data={share_arrow} fill='none'></Icon>
					<small class="ModalIdea__interaction__label">
						Share
					</small>
				</div>
			</div>
		</div>
	{:else}
		<Loader></Loader>
	{/if}
</div>